module.exports = {
	messages: {
		form: {
			title: "Criando Acesso",
			subTitle: "Formulário de Cadastro",
			introduction: {
				start:
					"Como parte da política corporativa da PagBrasil de avaliação de risco e em conformidade com as leis brasileiras, particularmente para os efeitos das legislações de prevenção à lavagem de dinheiro e ao financiamento do terrorismo, necessitamos coletar certas informações relacionadas aos clientes com quem estabelecemos uma relação de negócio.",
				highlight:
					"A informação recolhida neste formulário não será compartilhada com terceiros sem o consentimento do estabelecimento,",
				end:
					"exceto quando necessário para cumprir as obrigações legais e regulatórias.",
			},
			useTermsAgree: "Concordo com os ",
			useTerms: "Termos de uso",
		},
		yes: "Sim",
		no: "Não",
	},
	buttons: {
		createAccess: "Criar acesso",
	},
	steps: [
		"Dados Pessoais",
		"Informações do estabelecimento",
		"Proprietário(s) e contatos",
		"Tipo de integração",
		"Documentação",
		"Dados bancário",
	],
	useTerms: [
		{
			text:
				"PT Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Viverra maecenas accumsan lacus vel facilisis volutpat est. Metus vulputate eu scelerisque felis imperdiet proin fermentum leo vel. Nunc aliquet bibendum enim facilisis gravida neque convallis.",
		},
		{
			text:
				"PT Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
			subTerms: [
				{
					text:
						"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident",
				},
				{
					text:
						"On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire, that they cannot foresee the pain and trouble that are bound to ensue",
				},
			],
		},
		{
			text:
				"PT Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Viverra maecenas accumsan lacus vel facilisis volutpat est. Metus vulputate eu scelerisque felis imperdiet proin fermentum leo vel. Nunc aliquet bibendum enim facilisis gravida neque convallis.",
		},
		{
			text:
				"PT Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
			subTerms: [
				{
					text:
						"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident",
				},
				{
					text:
						"On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire, that they cannot foresee the pain and trouble that are bound to ensue",
				},
			],
		},
	],
};
